import { Injectable } from '@angular/core';

export enum LogLevelEnum {
  ERROR = 1,
  WARN = 2,
  INFO = 3,
  DEBUG = 4,
}

@Injectable({ providedIn: 'root' })
export class LogService {
  private currentLoggingLevel = 4;
  private isDevMode = true;
  // 0 = nothing
  // 1 = only errors
  // 2 = errors and warnings
  // 3 = errors, warning and infos
  // 4 = errors, warning, infos and debug

  constructor() {
    /*
    if(environment.production){
      console.log('Running in production mode');
      this.isDevMode = false;
    }else{
      console.log('Running in developer mode');
      this.isDevMode = true;
    } 
    */
    console.log('Running in developer mode');
    this.isDevMode = true;
  }

  userChanged(isAdminOrTech: boolean) {
    if (!this.isDevMode) {
      if (isAdminOrTech) {
        console.log('Logging: errors, warning, infos and debug');
        this.currentLoggingLevel = 4;
      } else {
        console.log('Logging: errors and warnings');
        this.currentLoggingLevel = 2;
      }
    } else {
      console.log('Logging: errors, warning, infos and debug');
      this.currentLoggingLevel = 4;
    }
  }

  error(message?: any, payload?: any) {
    if (this.currentLoggingLevel >= 1) {
      if (payload != null) {
        console.error(message, payload);
      } else {
        console.error(message);
      }
    }
  }

  warning(message?: any, payload?: any) {
    if (this.currentLoggingLevel >= 2) {
      if (payload != null) {
        console.warn(message, payload);
      } else {
        console.warn(message);
      }
    }
  }

  info(message?: any, payload?: any) {
    if (this.currentLoggingLevel >= 3) {
      if (payload != null) {
        console.info(message, payload);
      } else {
        console.info(message);
      }
    }
  }

  debug(message?: any, payload?: any) {
    if (this.currentLoggingLevel >= 4) {
      if (payload != null) {
        console.log(message, payload);
      } else {
        console.log(message);
      }
    }
  }
}
